import type { FC } from 'react';
import { FullPageLoader } from '@makemydeal/dr-sales-checkin-components';
import { CenteredLoadingIndicator } from './LoadingPage.style';

export const LoadingPage: FC<any> = () => (
    <CenteredLoadingIndicator data-testid="loading-indicator">
        <FullPageLoader message="Loading application" />
    </CenteredLoadingIndicator>
);
